import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { fetchWrapper } from "../_helpers";
// Create slice


const initialDocumentData = {
  title: "",
  activeStatus: 2,
  fromDate: "",
  toDate: "",
  pageNo: 1,
  rowCountPerPage: 10,
  SortField: "",
  facilityID: 0,
};

const name = "documents";
const initialState = createInitialState();
const reducers = createReducers();
const extraActions = createExtraActions();

const slice = createSlice({
  name,
  initialState,
  reducers,
  extraReducers: (builder) => {
    createExtraReducers(builder);
  },
});

// Exports
export const documentsActions = { ...slice.actions, ...extraActions };
export const documentsReducer = slice.reducer;

// Implementation

function createInitialState() {
  return {
    documents: [],
    griddata: [],
    documentList: [],
    loaddata: [],
    documentsList: [],
    deleteResponse: [],
    updatedataResponse: [],
    insertdataResponse: [],
    documentSearch:initialDocumentData,
    loading: false,
    error: null,
  };
}

function createReducers() {
  return {
    setdocumentsList,
    clearGetDocumentDetails,
    clearUploadDocument,
    clearUpdateDocument,
    clearDeleteDocument,
    clearDeleteDocumentExcelList,
    setDocumentSearch,
    clearDocuments,
  };
  /// clear funcs
  function clearGetDocumentDetails(state) {
    state.griddata = [];
  }
  function clearUpdateDocument(state) {
    state.updatedataResponse = [];
  }
  function clearUploadDocument(state) {
    state.insertdataResponse = [];
  }
  function clearDeleteDocument(state) {
    state.deleteResponse = [];
  }
  function clearDeleteDocumentExcelList(state) {
    state.documentList = [];
  }
    function setDocumentSearch(state, action) {
      state.documentSearch = action && action.payload;
    }

    function clearDocuments(state) {
      state.documentSearch = initialDocumentData;
    }

  // Manually set menu list if needed
  function setdocumentsList(state, action) {
    state.documentsList = action.payload;
  }
}

function createExtraActions() {
  const baseUrl = `${process.env.REACT_APP_API_URL}/ManagementUser/Document`;

  return {
    LoadDocumentList: LoadDocumentList(),
    GetDocumentDetails: GetDocumentDetails(),
    DeleteDocument: DeleteDocument(),
    UpdateDocument: UpdateDocument(),
    UploadDocument: UploadDocument(),
  };
  function LoadDocumentList() {
    return createAsyncThunk(`${name}/LoadDocumentList`, async (params) => {
      return await fetchWrapper.post(`${baseUrl}/LoadDocumentList`, params);
    });
  }

  /// Grid Click..
  function GetDocumentDetails() {
    return createAsyncThunk(
      `${name}/GetDocumentDetails`,
      async (DocumentID) => {
        return await fetchWrapper.get(
          `${baseUrl}/GetDocumentDetails?documentID=${DocumentID}`
        );
      }
    );
  }

  /// Grid delete..
  function DeleteDocument() {
    return createAsyncThunk(`${name}/DeleteDocument`, async (payload) => {
      return await fetchWrapper.post(`${baseUrl}/DeleteDocument`, payload);
    });
  }

  ///update grid..
  function UpdateDocument() {
    return createAsyncThunk(`${name}/UpdateDocument`, async (params) => {
      return await fetchWrapper.post(`${baseUrl}/UpdateDocument`, params);
    });
  }

  ///Add Doc Infm..
  function UploadDocument() {
    return createAsyncThunk(`${name}/UploadDocument`, async (params) => {
      return await fetchWrapper.post(`${baseUrl}/UploadDocument`, params);
    });
  }
}

function createExtraReducers(builder) {
  builder
    /// grid load
    .addCase(extraActions.LoadDocumentList.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(extraActions.LoadDocumentList.fulfilled, (state, action) => {
      let params = action.meta.arg;
      if (params?.exportExcel) {
        state.documentList = action.payload;
      } else {
        state.loaddata = action.payload;
      }

      state.loading = false;
      state.error = null;
    })
    .addCase(extraActions.LoadDocumentList.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message;
    })
    /// grid click
    .addCase(extraActions.GetDocumentDetails.pending, (state) => {
      state.loading = true;
      state.error = null;
    })

    .addCase(extraActions.GetDocumentDetails.fulfilled, (state, action) => {
      state.loading = false;
      state.griddata = action.payload;
    })
    .addCase(extraActions.GetDocumentDetails.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error;
    })

    /// grid delete
    .addCase(extraActions.DeleteDocument.pending, (state) => {
      state.loading = true;
      state.error = null;
    })

    .addCase(extraActions.DeleteDocument.fulfilled, (state, action) => {
      state.loading = false;
      state.deleteResponse = action.payload;
    })
    .addCase(extraActions.DeleteDocument.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error;
    })
    /// grid UpdateDocument
    .addCase(extraActions.UpdateDocument.pending, (state) => {
      state.loading = true;
      state.error = null;
    })

    .addCase(extraActions.UpdateDocument.fulfilled, (state, action) => {
      state.loading = false;
      state.updatedataResponse = action.payload;
    })
    .addCase(extraActions.UpdateDocument.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error;
    })

    /// Add Doc
    .addCase(extraActions.UploadDocument.pending, (state) => {
      state.loading = true;
      state.error = null;
    })

    .addCase(extraActions.UploadDocument.fulfilled, (state, action) => {
      state.loading = false;
      state.insertdataResponse = action.payload;
    })
    .addCase(extraActions.UploadDocument.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error;
    });
}
